import { Box, Table as MantineTable, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useContext } from 'react';

import { SortDirection } from '@e-origin/shared';

import { TABLE_HEADER_ICON_STROKE_SELECTED, TABLE_HEADER_ICON_STROKE_UNSELECTED } from '@constants';
import { TableColumnProps } from '../Table';
import { TableContext } from '../TableContext';
import classes from './TableHeader.module.css';

interface TableHeaderProps<T> {
  readonly columns: TableColumnProps<T>[];
  readonly onSortingChange: (direction: SortDirection, field: string) => void;
  readonly defaultSorting?: {
    field: string;
    direction: SortDirection;
  };
}

export const TableHeader = <T,>({ columns, onSortingChange, defaultSorting }: TableHeaderProps<T>) => {
  const { stickyClasses } = useContext(TableContext);

  const handleSorting = (column: TableColumnProps<T>) => {
    const field = column.selector;
    const sorting = {
      direction: defaultSorting.direction === SortDirection.ASC && field === defaultSorting.field ? SortDirection.DESC : SortDirection.ASC,
      field,
    };
    onSortingChange(sorting.direction, sorting.field);
  };

  return (
    <MantineTable.Thead className={classes.header}>
      <MantineTable.Tr>
        {columns
          .filter((column) => !column.hide)
          .map((column, index) => {
            const Icon = defaultSorting.direction === SortDirection.ASC && defaultSorting.field === column.selector ? IconChevronUp : IconChevronDown;
            const iconStroke = defaultSorting.field === column.selector ? TABLE_HEADER_ICON_STROKE_SELECTED : TABLE_HEADER_ICON_STROKE_UNSELECTED;
            return (
              <MantineTable.Th
                key={`tableHeader${index}`}
                fw={300}
                fz="xs"
                style={{ ...column.style, width: column.width }}
                className={`${column.sticky === 'right' ? stickyClasses.headerRight : stickyClasses.header} ${classes.headerCell}`}
              >
                {column.sortable ? (
                  <UnstyledButton className={classes.control} onClick={() => handleSorting(column)}>
                    <Box className={classes.innerHeader}>
                      <Text fz="xs" fw={defaultSorting.field === column.selector ? '700' : '300'}>
                        {column.name}
                      </Text>
                      <Box>
                        <Icon className={classes.sortIcon} size="0.9rem" stroke={iconStroke} />
                      </Box>
                    </Box>
                  </UnstyledButton>
                ) : (
                  column.name
                )}
              </MantineTable.Th>
            );
          })}
      </MantineTable.Tr>
    </MantineTable.Thead>
  );
};
